import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EndClientReport, EndClientReportTemplate } from '../../../models/end-client-reporting-package';

/**
 * The design history, as a popup over the deck rather than a column beside it.
 *
 * It is opened now and then and mostly read -- who changed the report, when, and a way back -- so a
 * rail that squeezed the deck for as long as it was open was more room than it needed, and less than
 * its list wanted. A restore closes it: the deck behind it is reloaded at the version restored, and
 * that is what the person restoring wants to look at next.
 *
 * Opened with `reportId` -- or `templateId` for a template's history (NK-450) -- and `disabled` in
 * initialState; `onRestored` / `onTemplateRestored` are how the page hears of a restore, the same
 * way the other popups hand back what they did.
 */
@Component({
  selector: 'or-report-history-modal',
  standalone: false,
  // The report's popup look -- see .ecr-modal in themes/end-client-reporting.scss.
  host: { class: 'ecr-modal' },
  template: `
    <div class="modal-header">
      <h5 class="modal-title nav-font16 font-weight-bold">History</h5>
      <button type="button" class="close" aria-label="Close history" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <or-report-history [reportId]="reportId"
                         [templateId]="templateId"
                         [disabled]="disabled"
                         [showHeader]="false"
                         (designReverted)="restored($event)"
                         (templateReverted)="templateRestored($event)"></or-report-history>
    </div>
  `,
})
export class ReportHistoryModalComponent {
  /** The report whose history this is. */
  reportId = '';
  /** A template's history instead (NK-450). */
  templateId = '';
  /** Set while the deck is being edited by hand, when a restore would fight the edit. */
  disabled = false;
  /** Told of a restore, with the report as it now stands. */
  onRestored?: (report: EndClientReport) => void;
  /** The template counterpart of `onRestored`. */
  onTemplateRestored?: (template: EndClientReportTemplate) => void;

  constructor(private modal: BsModalRef) { }

  restored(report: EndClientReport) {
    this.onRestored?.(report);
    this.modal.hide();
  }

  templateRestored(template: EndClientReportTemplate) {
    this.onTemplateRestored?.(template);
    this.modal.hide();
  }

  close() {
    this.modal.hide();
  }
}
